import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
} from 'reactstrap';
import { GlobalContext } from 'api/GlobalContext';
import { fetchUserDetails } from '../../components/Misc/apiUtils';

// Import your image (make sure you have the image in your project directory)
import mfaImage from '../../assets/img/brand/2fa.png';

const MultiFactorAuth = () => {
  const { apiClient } = useContext(GlobalContext);
  const [qrCodeUri, setQrCodeUri] = useState(null);
  const [isMFAEnabled, setIsMFAEnabled] = useState(false);
  const [mfaCode, setMfaCode] = useState('');
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [isMfaVerified, setIsMfaVerified] = useState(false); // New state variable
  let qrCodeScreenText =
    'Install Duo mobile app and scan the QR code to set up Multi-Factor Authentication.';
  let mfaScreenText =
    'Whenever you sign into your account, you will need to enter both your password and a security code from your mobile device using the Duo mobile app.';

  useEffect(() => {
    // Fetch user details
    fetchUserDetails(apiClient)
      .then((userDetails) => {
        // Extract user email from user details
        setIsMFAEnabled(userDetails?.mfaEnabled);
        setUserEmail(userDetails.email || '');
      })
      .catch((error) => {
        console.error('Error fetching user details:', error);
      });
  }, [apiClient]);

  const handleEnableClick = () => {
    console.log('Enabling MFA...');
    apiClient
      .updateMultiFactorAuth() // Enable MFA
      .then((response) => {
        console.log('MFA response:', response);
        if (response.result === 'success') {
          setQrCodeUri(response.qr_code_uri);
          setIsMFAEnabled(true); // Update the MFA state
        }
      })
      .catch((error) => console.error('Error updating MFA:', error));
  };

  const handleVerifyClick = () => {
    console.log('Verifying MFA Code...');
    apiClient
      .verifyMultiFactorAuth(userEmail, mfaCode)
      .then((response) => {
        console.log('Verification response:', response);
        if (response.success) {
          setVerificationStatus('MFA setup verified successfully!');
          setIsMfaVerified(true); // Update the MFA verification state
        } else {
          setVerificationStatus(
            'MFA setup verification failed. Please enter the MFA code again. If the issue persists, delete the existing entry in the Duo app and scan the QR code again.',
          );
        }
      })
      .catch((error) => {
        console.error('Error verifying MFA:', error);
        setVerificationStatus(
          'An error occurred during verification. Please try again.',
        );
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleVerifyClick();
    }
  };

  return (
    <Container className="text-center">
      <Row className="justify-content-center">
        <Col md="8">
          <h3>
            {isMFAEnabled
              ? 'Multi-Factor Authentication Enabled'
              : 'Enable Multi-Factor Authentication'}
          </h3>
          <img
            src={isMFAEnabled ? qrCodeUri || mfaImage : mfaImage}
            alt="Multi-Factor Authentication"
            className="img-fluid my-4"
          />
          <p>
            {isMFAEnabled
              ? qrCodeUri
                ? qrCodeScreenText
                : mfaScreenText
              : mfaScreenText}
          </p>
          {qrCodeUri && (
            <Form>
              <FormGroup>
                <Label for="mfaCode">Enter MFA Code</Label>
                <Input
                  type="text"
                  name="mfaCode"
                  id="mfaCode"
                  placeholder="Enter the security code from the Duo mobile app"
                  value={mfaCode}
                  onChange={(e) => setMfaCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </FormGroup>
              {!isMfaVerified && ( // Conditionally render the Verify button
                <Button color="primary" onClick={handleVerifyClick}>
                  Verify
                </Button>
              )}
              {verificationStatus && <p>{verificationStatus}</p>}
            </Form>
          )}
          {!isMFAEnabled && (
            <Button color="primary" onClick={handleEnableClick}>
              Enable
            </Button>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default MultiFactorAuth;
